import React, { useState, useEffect, useRef } from 'react';
import { BiSolidBell } from 'react-icons/bi';
import { IoMdClose } from 'react-icons/io';
import StyledHeadingText from '../Fonts/StyledHeadingText';

function NotificationDropdown() {
    const [notifications, setNotifications] = useState([
        { id: 1, message: 'New feature coming soon!', time: '2 hours ago', type: 'update', read: false },
        { id: 2, message: 'System maintenance scheduled', time: 'Yesterday', type: 'alert', read: false },
        { id: 3, message: 'Your subscription has been renewed', time: '1 week ago', type: 'payment', read: true },
    ]);

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Toggle dropdown visibility
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
        // Mark notifications as read when opening
        if (!isDropdownOpen) {
            setNotifications(notifications.map(n => ({ ...n, read: true })));
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Count unread notifications
    const unreadCount = notifications.filter(n => !n.read).length;

    return (
        <div className="relative" ref={dropdownRef}>
            {/* Notification Bell with Badge */}
            <div
                className="relative p-2 rounded-full hover:bg-gray-800/30 transition-colors cursor-pointer"
                onClick={toggleDropdown}
            >
                <BiSolidBell className="text-white text-xl" />
                {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                        {unreadCount}
                    </span>
                )}
            </div>

            {/* Dropdown Panel */}
            {isDropdownOpen && (
                <div className="absolute right-0 mt-2 z-50 w-80 bg-white rounded-lg shadow-xl overflow-hidden border border-gray-200">
                    {/* Header */}
                    <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gray-50">
                        <StyledHeadingText
                            text="Notifications"
                            TextColor="text-gray-800"
                            className="text-lg font-semibold"
                        />
                        <button
                            onClick={toggleDropdown}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <IoMdClose size={18} />
                        </button>
                    </div>

                    {/* Notification List */}
                    <div className="max-h-96 overflow-y-auto">
                        {notifications.length > 0 ? (
                            <ul className="divide-y divide-gray-100">
                                {notifications.map((notification) => (
                                    <li
                                        key={notification.id}
                                        className={`p-4 hover:bg-gray-50 transition-colors ${!notification.read ? 'bg-blue-50' : ''}`}
                                    >
                                        <div className="flex items-start">
                                            <div className="flex-1 min-w-0">
                                                <p className={`text-sm font-medium ${!notification.read ? 'text-gray-900' : 'text-gray-600'}`}>
                                                    {notification.message}
                                                </p>
                                                <p className="text-xs text-gray-500 mt-1">
                                                    {notification.time}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="p-4 text-center text-gray-500 text-sm">
                                No notifications available
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default NotificationDropdown;